import SubmissionPeriodModal from "./AssignSubmissionPeriodModal";
import ChangeSubmissionStatusModal from "./ChangeSubmissionStatusModal";
import AddSubmissionPeriodModal from "./AddSubmissionPeriodModal";
import RemoveSubmissionPeriodModal from "./RemoveSubmissionPeriodModal";
import ChangeTerritoryModal from "./ChangeTerritoryModal";
import ChangeConsumerNoticeModal from "./ChangeConsumerNoticeModal";
import ViewConsumerNoticeModal from "./ViewConsumerNoticeModal";
import ExportModal from "./ExportModal";
import RejectVoidAcceptedSubmissionModal from "./RejectVoidAcceptedSubmissionModal";
import ChangeAssigneeModal from "./ChangeAssigneeModel";
import RemoveOverdueModal from "./RemoveOverdueModal";
import DeleteConfirmationModal from "./DeleteConfirmationModal";
import SubmissionPeriodStatusActiveSwitchModal from "./SubmissionPeriodStatusActiveSwitchModal";
import ChangeCncStatusConfirmationModal from "./ChangeCncStatusConfirmationModal";
import ViewConsumerNoticeModalV2 from "./ViewConsumerNoticeModalV2";

export { default as Card } from "./Card";
export { default as Table } from "./Table";

export const MODALS = {
  addSubmissionPeriod: AddSubmissionPeriodModal,
  removeSubmissionPeriod: RemoveSubmissionPeriodModal,
  submissionPeriodModal: SubmissionPeriodModal,
  changeSubmissionStatusModal: ChangeSubmissionStatusModal,
  changeConsumerNoticeModal: ChangeConsumerNoticeModal,
  changeCncStatusConfirmationModal: ChangeCncStatusConfirmationModal,
  viewConsumerNoticeModal: ViewConsumerNoticeModal,
  viewConsumerNoticeModalV2: ViewConsumerNoticeModalV2,
  changeTerritoryModal: ChangeTerritoryModal,
  exportModal: ExportModal,
  rejectVoidAcceptedSubmissionModal: RejectVoidAcceptedSubmissionModal,
  changeAssigneeModal: ChangeAssigneeModal,
  removeOverdueModal: RemoveOverdueModal,
  deleteSubmissionPeriodModal: DeleteConfirmationModal,
  submissionPeriodStatusActiveSwitchModal:
    SubmissionPeriodStatusActiveSwitchModal,
};
